import AjaxService from '@services/AjaxService';
import BaseRepository, {SelectOption} from '@repositories/desktop/BaseRepository';

export default class InsuranceRepository extends BaseRepository {
  protected baseUrl = '/api/desktop/insurances';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}`, {data: {attributes}});
  }

  public delete(id: number): Promise<any> {
    return this.ajaxService.sendDelete(`${this.baseUrl}/${id}/delete`);
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/blank`);
  }

  public getContactFirmOptions<T = number | string>(id: number): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(
      `${this.baseUrl}/${id}/contacts/firms/options`
    ).then(r => r.data.attributes.options);
  }

  public getCountryOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/country`)
      .then(r => r.data.attributes.options);
  }

  public getParentInsuranceOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/parent-insurance`)
      .then(r => r.data.attributes.options);
  }

  public getRegionOptions<T = number | string>(countryId: number): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/country/${countryId}/region`)
      .then(r => r.data.attributes.options);
  }

  public loadContactCreationForm(id: number): Promise<any> {
    return this.ajaxService.getJson(
      `${this.baseUrl}/${id}/contacts/blank`
    );
  }

  public loadOverview(id: number): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/${id}`);
  }

  public saveBasedata(id: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `${this.baseUrl}/${id}/basedata/save`,
      {data: {attributes}}
    );
  }
  public saveContact(id: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `${this.baseUrl}/${id}/contacts`,
      {data: attributes}
    );
  }
}
